import app from '@/app';
import templateUrl from './allPlansByRoad-search.html';

/* @ngInject */
function AllPlansByRoadSearchController($controller, $state, DialogService, Plan, $http, Principal, $translate) {
  var $ctrl = this;
  var resource = Plan;
  $ctrl.allPlans = [];

  $ctrl.currentAccount = null;

  Principal.identity().then(account => {
    $ctrl.currentAccount = account;
  });

  $controller('AbstractPageSortController', { $ctrl: $ctrl });

  var transition = $ctrl.transition;

  $ctrl.onRoadTypeChange = roadtype => {
    $ctrl.road = null;
    $ctrl.campaigns = [];
    $ctrl.campaign = null;
  };

  $ctrl.onOrganizationChange = organization => {
    $ctrl.allPlans = Plan.query({plantype: 'DEFAULT'}, {organization: organization.id})
  };

  $ctrl.byOrganization = value =>
    $ctrl.organization && value.organization.id == $ctrl.organization.id;

  $ctrl.byOwner = value => $ctrl.organization && value.owner.id == $ctrl.organization.id;

  $ctrl.onQueryChange = function () {
    var state = 'allPlansByRoad.result';
    $state.go(
      state,
      {
        page: 0,
        plans: _.map($ctrl.allPlans, function(plan) {
          return Number(plan.id); // ou `parseInt(plan.id, 10)` se preferir
      })
      },
      {
        reload: true
      }
    );

    $ctrl.clearUiSelect = function ($event, $select, field) {
      $event.stopPropagation();
      $select.selected = null;
      $select.search = null;

      field = null;
    };

  }
}

app.component('allPlansByRoadSearch', {
  templateUrl,
  controller: AllPlansByRoadSearchController,
  bindings: {
    $transition$: '<',
    allOrganizations: '<',
    allRoads: '<',
    allCampaigns: '<',
    allDecisionTrees: '<',
    allCostTables: '<',
    allGrowthRates: '<',
    allPlans: '<'
  }
});
